import { AudioHighlightMetadata } from '@modules/feedback/components/AudioType/types';
import { FeedbackLabel } from 'v2/core/entities/feedback';

export const getHighlightForSelectedLabel = (
  highlightMetadata: AudioHighlightMetadata[],
  selectedLabels: FeedbackLabel[],
) => {
  if (!selectedLabels.length) {
    return undefined;
  }

  return highlightMetadata.find(
    (highlight) => highlight.labelID === selectedLabels[0].id,
  );
};
